export default __webpack_public_path__ + "static/media/accv.84984bfc.svg";